import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom, Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {WINDOW} from './window.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  subscriptionBaseUrl = environment.baseUrls().api + 'subscriptions/';

  constructor(private httpClient: HttpClient,
              @Inject(WINDOW) private window: Window,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  async unsubscribe(email: string, list: string) {
    if (isPlatformBrowser(this.platformId)) {
      return firstValueFrom(
        this.httpClient
          .post<any>(this.subscriptionBaseUrl + 'unsubscribe', {email: email, list: list})
      );
    } else {
      return firstValueFrom(of(null));
    }
  }
}
